import useActionBooking from './useActionBooking';
import useActionBookingStationTime from './useActionBookingStationTime';
import useActionStartTime from './useActionStartTime';
import useActionPaid from './useActionPaid';
import useActionPlayer from './useActionPlayer';
import useActionExperience from './useActionExperience';
import useActionStation from './useActionStation';
import useActionTier from './useActionTier';
import useActionPromo from './useActionPromo';
import useActionLoading from './useActionLoading';
import useActionConflict from './useActionConflict';
import useActionSaveCancel from './useActionSaveCancel';

export default function useBookingActions (
  locationId,
  location,
  bookings,
  currentTime,
  booking,
  bookingInStore,
  bookingChanges,
  startTime,
  paid,
  bookingStationTimes,
  bookingStationTimesInStore,
  bookingStationTimesChanges,
  experiences,
  stations,
  getExperienceStations,
  getExperienceTiers,
  tierPriceToLocationPrice,
) {
  const { bookingConflict, setConflictBooking, longestTierLength } = useActionConflict(bookings, booking, currentTime, startTime);

  const { editBooking } = useActionBooking(bookingInStore, bookingChanges);
  const { editBookingStationTime, addBookingStationTime, removeBookingStationTime, undoRemoveBookingStationTime } = useActionBookingStationTime(booking, bookings, startTime, bookingStationTimes, bookingStationTimesInStore, bookingStationTimesChanges, experiences, getExperienceStations, getExperienceTiers, tierPriceToLocationPrice, editBooking);

  const { setStartingTime, setStartingTimeNow } = useActionStartTime(editBooking, startTime, bookingStationTimes, editBookingStationTime);
  const { toggleMarkAsPaid } = useActionPaid(booking, paid, editBookingStationTime);
  const { handlePlayers } = useActionPlayer(booking, bookingStationTimes, editBooking);

  const { stationAction } = useActionStation(editBookingStationTime, handlePlayers);
  const { tierAction } = useActionTier(startTime, paid, editBookingStationTime, tierPriceToLocationPrice);
  const { experienceAction } = useActionExperience(getExperienceTiers, getExperienceStations, editBookingStationTime, stationAction, tierAction);
  const { couponAction, discountAction } = useActionPromo(locationId, paid, experiences, bookingStationTimes, editBookingStationTime);

  const { saving, isLoading } = useActionLoading(location, stations, experiences);
  const { storeBooking, cancelBooking } = useActionSaveCancel(locationId, booking, bookings, bookingChanges, startTime, bookingStationTimes, bookingStationTimesChanges, saving);

  return {
    bookingConflict,
    setConflictBooking,
    longestTierLength,
    editBooking,
    addBookingStationTime,
    removeBookingStationTime,
    undoRemoveBookingStationTime,
    setStartingTime,
    setStartingTimeNow,
    toggleMarkAsPaid,
    stationAction,
    tierAction,
    experienceAction,
    couponAction,
    discountAction,
    saving,
    isLoading,
    storeBooking,
    cancelBooking,
  };
}
